
export interface SenseCoreConfig {
    ApiUrl: string;
    ImageUrl: string;
    DebugMode: boolean;
    DebugStreamMode: boolean;
    H5Server: string;
    H5FlashSwf: string;
    ApiVersion?: string;
}

var config: SenseCoreConfig = {
    ApiUrl: '/api',
    ImageUrl: '//img.thuis.nl',
    DebugMode: false,
    DebugStreamMode: false,
    H5Server: '',
    H5FlashSwf: '',
};

export function setConfig(newConfig: SenseCoreConfig){
    config = Object.assign(config, newConfig);
}

export default config;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./node_modules/sensejs/core/config.ts